import { ANALYTICAL_REPORT_DOWNLOAD, DASHBOARD_VIEW, GRAPH_CARD } from "./types";

export const dashboardView = (onSuccess, onError) => {
  return {
    type: DASHBOARD_VIEW,
    onSuccess,
    onError,
  };
};
export const analyticalReportDownload = (data, onSuccess, onError) => {
  return {
    type: ANALYTICAL_REPORT_DOWNLOAD,
    data,
    onSuccess,
    onError,
  };
};

export const graphCard = (params, onSuccess, onError) => {
  return {
    type: GRAPH_CARD,
    params,
    onSuccess,
    onError,
  };
};
